import { Component } from '@angular/core';
import { FormComponentLookup } from '@ptl/forms';
import { MassUploadFormControlComponent } from '../../mass-upload-form-control.component';
import { EXCEL_PERSON_TYPES, MassUploadStateFormMap } from '../../../../../producer/mass-upload-grid/interfaces/mass-upload-grid.interface';
import { UntypedFormGroup } from '@angular/forms';

@FormComponentLookup('mass-upload-grid-control-status')
@Component({
  selector: 'app-mass-upload-status-form-control',
  templateUrl: './mass-upload-status-form-control.component.html',
  styleUrl: '../../mass-upload-form-control.component.scss',
  standalone: false
})
export class MassUploadStatusFormControlComponent extends MassUploadFormControlComponent {

  lastErrorString: string;
  errorString = '';
  
  ngOnInit() {
    super.ngOnInit();
    
    // The first column, which is the entry number column, will also be used as the error notifying column
    // The validation of each of these components is meant to be done completely before putting them on the UI
    // This means that when the user finally sees this, the validation should be complete and we can get an up
    // to date error message on component load. Even though on first load, there should be nothing to validate
    this.entry.massUploadAttributes.statusColumn = true;

    Object.keys(this.parentForm).forEach(formGroupKey => {
      const formGroup:UntypedFormGroup = this.parentForm[formGroupKey];
      this.subscriptionGroup.push(formGroup.statusChanges.subscribe((newStatus: string) => {
        // There is a delay between the removal of a row and the actual deconstruction of this component.
        // This checks to make sure this row state still exists before accessing the data
        if (!this.mugDataHelperService.gridFormMap.find((mapItem) => mapItem.stateId === this.stateId)) {
          return;
        }
        
        this.updateErrorString();
        this.selfAsFormControl.setValue(this.errorString, {emitEvent: false});

        // We have to track changes accross 4 different forms' status events, so we compare error strings for actual status changes
        if (this.lastErrorString != this.errorString) {
          this.lastErrorString = this.errorString;
          const ownerMap = this.mugDataHelperService.getOwnerFormMapFromStateId(this.stateId);

          // The item returned will be the owning subscriber. If the stateId does not match,
          // then we know we are in a dependent field. We then trigger the sub to update it's validity
          if (ownerMap?.stateId !== this.stateId) {
            ownerMap.formGroups[this.mugDataHelperService.getStatusFormKey(ownerMap.stateId)].updateValueAndValidity();
          }
        }
      }));
    });
  }

  updateErrorString() {
    this.errorString = '';

    // always validate this row's form regardless of person type
    this.validateFormGroup(this.parentForm);
        
    // If we are a dependent or a subscriber with no dependents there is nothing else to do
    const isSubscriber = this.mugDataHelperService.getPersonTypeByStateId(this.stateId) === EXCEL_PERSON_TYPES.SUBSCRIBER;
    if (!isSubscriber) {
      return;
    }

    let formGroupsToCheck: MassUploadStateFormMap[] = this.mugDataHelperService.getFullFamilyFormGroupsBySubscriberStateId(this.stateId);
    if (formGroupsToCheck?.length <=  1) {
      return;
    }

    // Check if any dependent is invalid. We only need to recognize if any dependent has an invalid status not specific errors. 
    // Specific errors will be handled by that specific dependent row
    for (let formGroupIndex = 1; formGroupIndex < formGroupsToCheck.length; formGroupIndex++) {
      if (!this.mugDataHelperService.isValidFormGroup(formGroupsToCheck[formGroupIndex])) {
        this.errorString += `Some Dependents are invalid, `;
        break;
      }
    }
      
    // Verify against our dependent validations that we do not have more dependents/spouses than we are allowed
    if (this.isTooManyDependents(formGroupsToCheck)) {
      this.errorString += 'Too Many Dependents';
    }
  }

  validateFormGroup(rowFormGroups:any) {
    // loop through each form group for this member
    //const rowFormGroups = formGroupsToCheck[formGroupIndex];
    const formGroupKeys = Object.keys(rowFormGroups);
    for (let i = 0; i < formGroupKeys.length; i++) {
      
      // if the form group is invalid, compile the list of invalid controls
      const formGroup:UntypedFormGroup = rowFormGroups[formGroupKeys[i]];
      if (formGroup && formGroup.invalid) {
        Object.keys(formGroup.controls).forEach(controlKey => {
          const control = formGroup.controls[controlKey];
          if (control.invalid) {
            this.errorString += controlKey + ', ';
          }
        });
      }
    }
  }

  isTooManyDependents(formMapItems: MassUploadStateFormMap[]): boolean {
    let numDeps = 0;
    let numSpouses = 0;

    formMapItems.filter((formMapItem) => {
      let personType = this.mugDataHelperService.getPersonTypeByStateId(formMapItem.stateId);

      if (personType === EXCEL_PERSON_TYPES.DEPENDENT) {
        numDeps++;
      }
      if (personType === EXCEL_PERSON_TYPES.SPOUSE) {
        numSpouses++;
      }
    });

    let enrollmentType = this.mugDataHelperService.getEnrollmentTypeByStateId(formMapItems[0].stateId);
    let depValidations = this.mugFormHelperService.getDependentValidations(enrollmentType);
    let spouseValidations = this.mugFormHelperService.getSpouseValidations(enrollmentType);

    if (numDeps > depValidations.maxDependents || numSpouses > spouseValidations.maxSpousalPartners) {
      return true;
    }

    return false;
  }
}
